import { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";

/**
 * Development-only Sentry verification overlay.
 * Only renders in Vite development mode (import.meta.env.DEV).
 * On mount it fires one controlled exception to launchtactix-web so the
 * pipeline can be confirmed in the Sentry dashboard without a manual click.
 * The button remains available for subsequent manual triggers.
 * Returns null (renders nothing) in production builds.
 */
export function DevSentryTest() {
  if (!import.meta.env.DEV) return null;
  return <DevSentryTestInner />;
}

function DevSentryTestInner() {
  const [eventId, setEventId] = useState<string | null>(null);
  const [triggered, setTriggered] = useState(false);

  // Auto-fire once on mount for pipeline verification.
  useEffect(() => {
    const id = Sentry.captureException(
      new Error("LaunchTactix frontend Sentry verification")
    );
    setEventId(id);
    setTriggered(true);
    console.info(
      "[Sentry] Frontend verification event sent to launchtactix-web. Event ID:", id,
    );
  }, []);

  function triggerManual() {
    const id = Sentry.captureException(
      new Error("LaunchTactix frontend Sentry verification")
    );
    setEventId(id);
    console.info("[Sentry] Manual verification event. Event ID:", id);
  }

  return (
    <button
      onClick={triggerManual}
      title={`Dev-only Sentry test. Last event: ${eventId ?? "pending…"}`}
      style={{
        position: "fixed",
        bottom: "8px",
        right: "8px",
        zIndex: 99999,
        fontSize: "10px",
        lineHeight: "1",
        padding: "3px 7px",
        background: triggered ? "rgba(0,140,0,0.75)" : "rgba(220,0,0,0.8)",
        color: "#fff",
        border: "none",
        borderRadius: "3px",
        cursor: "pointer",
        fontFamily: "monospace",
        opacity: 0.65,
        maxWidth: "200px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {triggered ? `Sentry ✓ ${eventId?.slice(0, 8) ?? ""}` : "Sentry·test"}
    </button>
  );
}
